import './App.css';

import React from 'react';
import logo from './sakura.svg';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Coming Soon...</p>
      </header>
    </div>
  );
}

export default App;
